import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SportService } from '@app/core/services';
import { CommonService } from '@app/core/services/common.service';
import { environment } from '@environments/environment';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ArticleComponent implements OnInit {
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  articles: any[] = [];
  assetUrl = environment.assetUrl;
  article: any = null;
  selectedSport = '';
  @Input() limit = 3;
  @Input() showFeatured = false;
  featuredArticle = null;
  /**
   *
   * @param {CommonService} _common
   * @param {SportService} _sport
   */
  constructor(
    public _common: CommonService,
    private _sport: SportService,
    private _activated: ActivatedRoute
  ) { }

  async ngOnInit() {
    this._activated.data.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.selectedSport = data['sport'] || this._sport.defaultSport;
      this._common
        .getArticles(
          new HttpParams().set('sport', this.selectedSport).set('limit', this.limit)
        )
        .then((res) => {
          this.articles = res.data;
          this.featuredArticle = res.featured;
        });
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
